import PracticePlay from './model';
import { moment } from 'omni-common-ui';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'studentId':
      return [key, `${val}`];
    case 'lastActivitiesCompletedDate':
      return [key, moment.utc(val)];
    default:
      return [key, val];
  }
};

const create = (data) => new PracticePlay(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/PracticePlay/model/create.js